import React, { useState } from 'react';
import {
    Button,
    Container,
    TextField,
    Table,
    Modal,
    TableBody,
    TableCell,
    Box,
    Typography,
    Toolbar,
    AppBar,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    InputAdornment,
    Tooltip,
    Snackbar
} from '@mui/material';
import LoadingBar from 'react-top-loading-bar';
import MuiAlert from '@mui/material/Alert';
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import base64 from "base64-js";


const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const FormModules = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const rowsPerPageOptions = [5, 10, 25, 50];
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [loadingBarProgress, setLoadingBarProgress] = useState(0);
    const [selectedModule, setSelectedModule] = useState({ moduleId: null, moduleName: '' });
    const [showModal, setShowModal] = useState(false);
    const [canDelete, setCanDelete] = useState(true);
    const [canEdit, setCanEdit] = useState(true);
    const [canAdd, setCanAdd] = useState(true);
    const [canRead, setCanRead] = useState(true);

    // Static data for the table
    const staticModules = [
        { moduleId: 1, moduleName: 'User Management', description: 'Manage user roles and permissions', status: 'Active' },
        { moduleId: 2, moduleName: 'Dashboard', description: 'Overview and analytics', status: 'Active' },
        { moduleId: 3, moduleName: 'Reports', description: 'Generate and export reports', status: 'Inactive' },
        { moduleId: 4, moduleName: 'Settings', description: 'Configure system settings', status: 'Active' },
        { moduleId: 5, moduleName: 'Notifications', description: 'Manage user notifications', status: 'Active' },
        { moduleId: 6, moduleName: 'Audit Logs', description: 'Track system activities', status: 'Inactive' },
    ];

     const decodeFormId = (encodedFormId) => {
    if (!encodedFormId || typeof encodedFormId !== "string") {
      console.error("encodedFormId is missing or invalid:", encodedFormId);
      return null;
    }
    try {
      const paddedEncodedFormId = encodedFormId.padEnd(Math.ceil(encodedFormId.length / 4) * 4, "=");
      const bytes = base64.toByteArray(paddedEncodedFormId);
      return new TextDecoder().decode(bytes);
    } catch (error) {
      console.error("Error decoding formId:", error);
      return null;
    }
  };

  const { encodedFormId } = useParams();
  const formId = decodeFormId(encodedFormId);

  const Authorizer = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ formId, }), // replace with actual formId if hardcoded
      });

      const result = await response.json();
      const data = result[0];

      // setAuthorization(data);
      setCanEdit(data?.uModify === 1);
      setCanAdd(data?.uWrite === 1);
      setCanDelete(data?.uDelete === 1);
      setCanRead(data?.uRead === 1);
    } catch (error) {
      console.error("Authorization check failed:", error);
    }
  };


    const handleAddModule = () => {
        // Navigate to add module page or open a modal
        navigate("/add-form-module")
    };

    const handleEdit = (moduleId) => {
        // Navigate to edit module page or open a modal
        navigate(`/edit-form-module/${moduleId}`);
    };

    const handleDelete = async () => {
        try {
            setLoadingBarProgress(30);
            // Simulate API call
            setTimeout(() => {
                setShowModal(false);
                setLoadingBarProgress(100);
                setSnackbarMessage('Module deleted successfully!');
                setOpenSnackbar(true);
            }, 1000);
        } catch (error) {
            console.error('API request error:', error);
            alert('An error occurred. Please try again later.');
        }
    };

    const handleShow = (moduleId, moduleName) => {
        setSelectedModule({ moduleId, moduleName });
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(1);
    };

    const filteredData = staticModules.filter((module) =>
        module.moduleName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        module.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        module.status.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const paginatedData = filteredData.slice(
        (page - 1) * rowsPerPage,
        page * rowsPerPage
    );

    return (
        <>{!canRead?(<h2 style={{color:'red'}}>You are not Authorized to View this Page!</h2>):
        (<Container mt={5}>
            <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
                <Toolbar>
                    <Typography variant="h4" component="div" style={{ fontWeight: "bold" }}>
                        Form Modules
                    </Typography>
                </Toolbar>
            </AppBar>
            <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>
                <LoadingBar progress={loadingBarProgress} color="rgb(152, 106, 182)" height={5} />
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem', marginLeft: '5px' }}>
                    <TextField
                        variant="outlined"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{ width: "300px" }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                            style: { padding: '0px 8px' },
                        }}
                        sx={{
                            width: 300,
                            backgroundColor: '#f9f9f9',
                        }}
                    />
                    <Tooltip title={!canAdd && "You are not Authorized to Add"} arrow>
                        <span>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleAddModule}
                                style={{
                                    width: "160px",
                                    height: "50px",
                                    padding: "10px 0",
                                    fontWeight: 'bold'
                                }}
                                disabled={!canAdd}
                            >
                                ADD NEW MODULE
                            </Button>
                        </span>
                    </Tooltip>
                </div>
                <TableContainer component={Paper} mt={3}>
                    <Table
                        sx={{
                            minWidth: 650,
                            border: '1px solid #ccc',
                            '& .MuiTableCell-root': {
                                borderRight: '1px solid #ccc',
                                fontSize: '1rem',
                            },
                            '& .MuiTableHead-root .MuiTableCell-root': {
                                fontWeight: 'bold',
                                backgroundColor: '#f5f5f5',
                            },
                        }}
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell>Module Name</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell align="center">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedData.map((module) => (
                                <TableRow key={module.moduleId}>
                                    <TableCell>{module.moduleName}</TableCell>
                                    <TableCell>{module.description}</TableCell>
                                    <TableCell>{module.status}</TableCell>
                                    <TableCell align="center">
                                        <Tooltip title={canEdit ? '' : 'You are not authorized to edit'} arrow>
                                            <span>
                                                <Button
                                                    variant="contained"
                                                    color="warning"
                                                    onClick={() => handleEdit(module.moduleId)}
                                                    disabled={!canEdit}
                                                    startIcon={<EditIcon />}
                                                    style={{ marginRight: '6px' }}
                                                >
                                                    Edit
                                                </Button>
                                            </span>
                                        </Tooltip>
                                        <Tooltip title={canDelete ? '' : 'You are not authorized to delete'} arrow>
                                            <span>
                                                <Button
                                                    variant="contained"
                                                    color="error"
                                                    onClick={() => handleShow(module.moduleId, module.moduleName)}
                                                    disabled={!canDelete}
                                                    startIcon={<DeleteIcon />}
                                                >
                                                    Delete
                                                </Button>
                                            </span>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <Modal open={showModal} onClose={handleClose} aria-labelledby="delete-modal-title" aria-describedby="delete-modal-description">
                        <Box
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: 400,
                                bgcolor: 'background.paper',
                                borderRadius: 2,
                                boxShadow: 24,
                                overflow: 'hidden',
                            }}
                        >
                            <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
                                <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
                                    Delete Confirmation ⚠️
                                </Typography>
                            </Box>
                            <Box sx={{ padding: '20px' }}>
                                <Typography id="delete-modal-description" sx={{ mb: 2 }}>
                                    Are you sure you want to delete <strong>{selectedModule?.moduleName}</strong>?
                                </Typography>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                                    <Button onClick={handleClose} variant="outlined" sx={{ mr: 1 }}>
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="error"
                                        onClick={handleDelete}
                                    >
                                        Yes, Delete
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Modal>
                </TableContainer>
                {filteredData.length > 0 && (
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
                        <TextField
                            select
                            label="Rows per page"
                            value={rowsPerPage}
                            onChange={handleChangeRowsPerPage}
                            sx={{ width: 150 }}
                            SelectProps={{
                                native: true,
                            }}
                        >
                            {rowsPerPageOptions.map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </TextField>
                        <Box>
                            <Typography variant="body2" sx={{ display: 'inline-block', marginRight: 2 }}>
                                Page {page} of {Math.ceil(filteredData.length / rowsPerPage)}
                            </Typography>
                            <Button
                                variant="outlined"
                                onClick={() => handleChangePage(null, page - 1)}
                                disabled={page === 1}
                                sx={{ mr: 1 }}
                            >
                                Prev
                            </Button>
                            <Button
                                variant="outlined"
                                onClick={() => handleChangePage(null, page + 1)}
                                disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
                            >
                                Next
                            </Button>
                        </Box>
                    </Box>
                )}
            </Paper>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={4000}
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Container>)}
        </>
    );
};

export default FormModules;
